module.exports = __webpack_public_path__ + "static/L4Gdev-Regular-0faa9212a07ad74b90f39d3f2474fc71.ttf";